// extracted by mini-css-extract-plugin
export default {"container":"GenericSummary_container__YRR1C","page":"GenericSummary_page__PmRFb","section":"GenericSummary_section__VAu5B","recaptcha":"GenericSummary_recaptcha__wpK39"};